module.exports = __webpack_public_path__ + "static/media/lovehero-min.6fcc6e54.jpg";